import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import FilterList from "@material-ui/icons/FilterList";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { ArrowBack } from "@material-ui/icons";
import { useAsyncEffect } from "use-async-effect";

import {
  getSlotsUtilization,getAllActiveDrivers
} from "../../network/ApiAxios";
import { redirectToLogout,dateSortFunc,
 numericSortFunc
 } from "common/SharedFn";


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SlotsUtilizationTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  // Filters open on request rather than always taking a row
  const [showFilters, setShowFilters] = useState(false);
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [driversList, setDriversList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [driverId, setDriverId] = useState(-1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  let history = useHistory();
  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchSlotsUtilization = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getSlotsUtilization(startDate, endDate,driverId);
      const { data } = response;
      const responseDrivers = await getAllActiveDrivers();
      if (data.result.isSuccess) {
        setDriversList(responseDrivers.data.data)
        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch slots utilization "+ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if(endDateStored != null && endDateStored.toUpperCase() !== "NULL"){
        setEndDate(new Date(endDateStored));
      }
      else{
        setEndDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if(startDateStored != null && startDateStored.toUpperCase() !== "NULL"){
        setStartDate(new Date(startDateStored));
      }
      else{
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
      if (startDate != null && endDate != null) {
        fetchSlotsUtilization();
      }
  }, [
    forceRefresh,
    startDate,
    endDate,
    driverId
  ]);

  const makeTableRow = (info) => {
    return {
      ...info
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>


              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "is",
                    text: "ID",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "date",
                    text: "Date",
                    sort: true,
                    sortFunc: dateSortFunc
                  },
                  {
                    dataField: "timeRange",
                    text: "Time Range",
                    sort: true,
                  },
                  {
                    dataField: "utilized",
                    text: "Utilized",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "available",
                    text: "Available",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                    <Tooltip title="Back">
                      <Button
                        size="small"
                        classes={{
                          root: classes.buttonContainedPrimary,
                        }}
                        variant="contained"
                        style={{ marginRight: "20px" }}
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        <Box component={ArrowBack} />
                      </Button>
                    </Tooltip>
                      <Box component="span">Slots utilization</Box>
                    </Box>
                      </>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                        <Tooltip title={showFilters ? "Hide filters" : "Filters"}>
                          <IconButton
                            onClick={() => setShowFilters((open) => !open)}
                            aria-expanded={showFilters}
                            aria-label="Filters"
                            style={{
                              width: 40, height: 40,
                              border: "1px solid #dee2e6", borderRadius: 8,
                              color: showFilters ? "#5e72e4" : "#525f7f",
                              backgroundColor: showFilters ? "#eef0fb" : "transparent",
                            }}
                          >
                            <FilterList style={{ width: 18, height: 18 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                    <Collapse in={showFilters}>
                      <Divider />
                      <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          From 
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);}}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                           to 
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            <Select value={driverId} onChange={(e) => {setDriverId(e.target.value);}} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={-1}>All Drivers</MenuItem>
                    {driversList.map(function(driver, i){
                        return <MenuItem value={driver.id}>{driver.fullNameEn}</MenuItem>;
                    })}
                    </Select>
                          </div>
                        </form>
                      </Grid>
                    </Grid>
                    </Collapse>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                  </>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default SlotsUtilizationTable;
